/**
 * AI 문서 아카이브 — 계약정보 (계약서·통장사본·사업자등록증)
 * 사업자등록증·통장사본은 향후 거래처마스터(cm_vendor/cm_vendor_account)에, 계약서는 계약대장에
 * 매핑되는 것을 전제로 한다 — 매핑 어댑터는 BE 연결 후 구현.
 * [[20260923-AI문서아카이브-OCR전자서명계약인사문서-통합설계분석]] §4.3, §3.3(멀티 엔티티 사례)
 */
import React from 'react';
import { PageContainer } from 'styles/common.styles';
import DocCaptureArchivePanel from 'archive/DocCaptureArchivePanel';

const ArchiveContract = () => (
  <PageContainer>
    <DocCaptureArchivePanel
      category="CONTRACT"
      panelTitle="인식 결과 확인·입력"
      uploadHint="계약서·통장사본·사업자등록증을 촬영/업로드하세요. 사업자등록증은 거래처마스터, 계약서는 계약대장 연동을 전제로 합니다."
      afterSaveHint="아카이브에 저장했습니다. (계약대장·거래처마스터 연동은 BE 매핑 어댑터 구현 후)"
    />
  </PageContainer>
);

export default ArchiveContract;
